import getValueOffPercent from 'lib/offer/getValueOffPercent'
import {
  BookmarkDatesAndOccupancy,
  SavedHotelData,
} from 'tripPlanner/types/tripItem'
import {
  CreateAccommodationRequestBody,
  formatTimeForPayload,
  getCheckInCheckOutOccupancy,
  getLeHotelCheckInAndOutTimes,
  getPlaceFromOffer,
} from 'tripPlanner/utils/itemConversions/common'

interface Params {
  offer: App.Offer | App.OfferSummary
  datesAndGuests: BookmarkDatesAndOccupancy
  currentRegionCode: string
  currencyCode: string
  price?: number
  value?: number
  roomTypeId?: string
  templateId?: string
  templateItemId?: string
}

export function createLEOfferItemPayload({
  offer,
  datesAndGuests,
  currentRegionCode,
  currencyCode,
  price,
  value,
  roomTypeId,
  templateId,
  templateItemId,
}: Params): CreateAccommodationRequestBody {
  if (
    offer.type === 'tour' ||
    offer.type === 'bundle_and_save' ||
    offer.type === 'rental'
  ) {
    // Just to satisfy Typescript. This shouldn't ever happen.
    throw new Error('Invalid offer type')
  }

  const discountPercent =
    typeof price === 'number' && typeof value === 'number' ?
      getValueOffPercent(value, price) :
      undefined

  // When we do not have any room option for selected dates/guests,
  // we won't get a price.
  // In such cases, we do not want to save dates/guests in the trip item
  const datesAndOccupancy =
    typeof price === 'number' ? getCheckInCheckOutOccupancy(datesAndGuests) : {}

  const savedHotelData: SavedHotelData = {
    regionCode: currentRegionCode,
    offerType: offer.type,
    currencyCode,
    offerId: offer.id,
    durationInDays: datesAndGuests.durationInDays,
    price,
    value,
    discountPercent,
    roomTypeId,
    roomTypeName: roomTypeId ?
      offer.packages.find((p) => p.roomType?.id === roomTypeId)?.roomType
        ?.name :
      undefined,
    ...datesAndOccupancy,
  }

  const [startTimeMoment, endTimeMoment] = getLeHotelCheckInAndOutTimes(offer)

  return {
    type: 'ACCOMMODATION',
    isBooked: false,
    sourceType: 'LE_Hotel',
    startDate: datesAndOccupancy.checkIn,
    endDate: datesAndOccupancy.checkOut,
    startTime: formatTimeForPayload(startTimeMoment),
    endTime: formatTimeForPayload(endTimeMoment),
    place: getPlaceFromOffer(offer),
    code: offer.id,
    subCode: roomTypeId,
    savedItemData: savedHotelData,
    templateId,
    templateItemId,
  }
}
